import React, { Fragment, useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogTitle,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import Select from "react-select";
import { useForm } from "react-hook-form";
import Loader from "../loader/loader";
import { toast } from "react-toastify";
import {
  getSubjectAllByContent,
  shareSupersheet,
  validateSupersheet,
} from "../../../api/supersheet.service";
const ShareSupersheet: React.FC<any> = ({
  supersheetId,
  subjectName,
  shareSubjectIds,
  contentAreas,
  title,
  buttonText,
  userId,
  confirmAction,
}: {
  confirmAction: (isConfirm: boolean) => void;
  supersheetId;
  subjectName: string;
  shareSubjectIds: string;
  contentAreas: Array<any>;
  title: string;
  buttonText: string;
  userId: number;
}) => {
  const initialState = {
    contentAreaId: 0,
    contentAreaName: "",
    subjectId: 0,
    subjectName: "",
  };

  const { handleSubmit } = useForm<any>();
  const [popupInput, setPopupInput] = useState<any>(initialState);
  const [loading, setLoading] = useState<boolean>(false);
  const [newSubject, setNewSubject] = useState<any>([]);
  const [errorContentArea, setErrorContentArea] = useState<string>("");
  const [errorSubject, setErrorSubject] = useState<string>("");

  const onSubmit = () => {
    if (!popupInput.contentAreaId || popupInput.contentAreaId == 0) {
      setErrorContentArea("Content Area should not be empty");
      return;
    }
    if (!popupInput.subjectId || popupInput.subjectId == 0) {
      setErrorSubject("Subject should not be empty");
      return;
    }
    const supersheet = {
      supersheetId: supersheetId,
      subjectId: popupInput.subjectId,
    };

    setLoading(true);
    validateSupersheet(supersheet).then((result) => {
      setLoading(false);
      if (!result.data) {
        shareSupersheet(supersheet).then(() => {
          postSuccess();
        });
      } else {
        postError();
      }
    });
  };

  const postSuccess = () => {
    toast.success("Supersheet added successfully");
    setTimeout(() => {
      confirmAction(true);
    }, 1000);
  };

  const postError = () => {
    toast.error("Supersheet is already exist for " + popupInput.subjectName);
    setTimeout(() => {
      confirmAction(true);
    }, 1000);
  };
  const bindSubjectByContent = async (contentAreaId) => {
    const response = getSubjectAllByContent(userId, 0, contentAreaId);
    const data = (await response).data.supersheetSubjectGroup;
    let newSubjectData = [];
    if (data.length > 0) {
      data.sort(
        (firstItem, secondItem) => firstItem.subjectId - secondItem.subjectId
      );
      newSubjectData = data
        .filter((s) => {
          return !shareSubjectIds.split(",").includes(s.subjectId.toString());
        })
        .map((eachSubjectData) => {
          return {
            value: eachSubjectData.subjectId || 0,
            label: `${eachSubjectData.subjectName}`,
          };
        });
    }
    setNewSubject(newSubjectData);
  };

  const updateDropdownValues = (updateObj) => {
    setErrorContentArea("");
    setErrorSubject("");
    if (updateObj.type == "ContentArea") {
      setPopupInput({
        ...popupInput,
        contentAreaId: updateObj.value || 0,
        contentAreaName: updateObj.label || 0,
        subjectId: 0,
        subjectName: "",
      });
      bindSubjectByContent(updateObj.value);
    } else if (updateObj.type == "Subject") {
      setPopupInput({
        ...popupInput,
        subjectId: updateObj.value || 0,
        subjectName: updateObj.label || 0,
      });
    }
  };

  return (
    <div>
      {loading && <Loader />}
      <Transition.Root show={true} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-10 inset-0"
          onClose={() => confirmAction(false)}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left  shadow-xl transform transition-all sm:my-8 sm:align-middle sm:p-6 w-1/4 h-27">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4"></div>
                  <div className="sm:flex sm:items-start">
                    <div className="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <DialogTitle as="h3" className="text-sm text-gray-700">
                        {title} for
                      </DialogTitle>
                      <p className="dark:text-white">{subjectName}</p>
                      <div className="mt-2">
                        <div className="grid grid-cols-1 divide-y divide-gray-300 border border-gray-300 rounded-lg ">
                          <div className="h-22 px-4 flex">
                            <div className="flex items-center w-full">
                              <div className="w-full py-4">
                                <label className="ml-3 mb-1 block text-sm font-medium text-gray-700">
                                  Content Area{" "}
                                </label>
                                <Select
                                  className="mt-1 text-sm"
                                  value={{
                                    label: popupInput.contentAreaName,
                                    value: popupInput.contentAreaId,
                                  }}
                                  onChange={(result) =>
                                    updateDropdownValues({
                                      ...result,
                                      type: "ContentArea",
                                    })
                                  }
                                  options={contentAreas}
                                  theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                      ...theme.colors,
                                      primary25: "#B3B3B3",
                                      primary: "#041E42",
                                    },
                                  })}
                                  styles={{
                                    control: (base, state) => ({
                                      ...base,
                                      background:
                                        document.getElementsByClassName("dark")
                                          ?.length > 0
                                          ? "#1A1C23"
                                          : "white",
                                      borderColor:
                                        document.getElementsByClassName("dark")
                                          ?.length > 0
                                          ? "#6B7280"
                                          : "#D1D5DB",
                                      borderWidth: "1px",
                                      "&:hover": {
                                        borderColor:
                                          state.isFocused &&
                                          document.getElementsByClassName(
                                            "dark"
                                          )?.length > 0
                                            ? "#6b7280"
                                            : state.isFocused
                                            ? "#4c5563"
                                            : "",
                                      },
                                    }),
                                    singleValue: (base) => ({
                                      ...base,
                                      color:
                                        document.getElementsByClassName("dark")
                                          ?.length > 0
                                          ? "white"
                                          : "#374051",
                                    }),
                                    input: (base) => ({
                                      ...base,
                                      color:
                                        document.getElementsByClassName("dark")
                                          ?.length > 0
                                          ? "white"
                                          : "",
                                    }),
                                  }}
                                />

                                <span className="text-red-700">
                                  {errorContentArea}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className=" h-22 px-4 flex w-full">
                            <div className="flex items-center w-full">
                              <div className="w-full py-4">
                                <label className="ml-3 mb-1 block text-sm font-medium text-gray-700">
                                  Subject{" "}
                                </label>
                                <Select
                                  value={{
                                    label: popupInput.subjectName,
                                    value: popupInput.subjectId,
                                  }}
                                  onChange={(result) =>
                                    updateDropdownValues({
                                      ...result,
                                      type: "Subject",
                                    })
                                  }
                                  options={newSubject}
                                  theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                      ...theme.colors,
                                      primary25: "#B3B3B3",
                                      primary: "#041E42",
                                    },
                                  })}
                                  styles={{
                                    control: (base, state) => ({
                                      ...base,
                                      background:
                                        document.getElementsByClassName("dark")
                                          ?.length > 0
                                          ? "#1A1C23"
                                          : "white",
                                      borderColor:
                                        document.getElementsByClassName("dark")
                                          ?.length > 0
                                          ? "#6B7280"
                                          : "#D1D5DB",
                                      borderWidth: "1px",
                                      "&:hover": {
                                        borderColor:
                                          state.isFocused &&
                                          document.getElementsByClassName(
                                            "dark"
                                          )?.length > 0
                                            ? "#6b7280"
                                            : state.isFocused
                                            ? "#4c5563"
                                            : "",
                                      },
                                    }),
                                    singleValue: (base) => ({
                                      ...base,
                                      color:
                                        document.getElementsByClassName("dark")
                                          ?.length > 0
                                          ? "white"
                                          : "#374051",
                                    }),
                                    input: (base) => ({
                                      ...base,
                                      color:
                                        document.getElementsByClassName("dark")
                                          ?.length > 0
                                          ? "white"
                                          : "",
                                    }),
                                  }}
                                />

                                <span className="text-red-700">
                                  {errorSubject}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                    <button
                      type="submit"
                      className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-color text-base font-medium text-white hover:bg-primary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:ml-3 sm:w-auto sm:text-sm dark:text-white"
                    >
                      {buttonText}
                    </button>
                    <button
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:mt-0 sm:w-auto sm:text-sm"
                      onClick={() => confirmAction(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </TransitionChild>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default ShareSupersheet;
